<!-- sms.component.html - Updated with proper translation state -->
<div class="editor-container" [class.translating]="isTranslating">
  <div class="editor-toolbar mat-elevation-z2">
    <div class="toolbar-left">
      <!-- Emoji Button (custom implementation) -->
      <button type="button" mat-icon-button class="emoji-btn" (click)="toggleEmojiPicker($event)"
        matTooltip="Insert emoji" [matMenuTriggerFor]="emojiFieldsMenu">
        <span>😊</span>
      </button>
      <mat-menu xPosition="after" yPosition="below" #emojiFieldsMenu="matMenu" class="emoji">
        <emoji-mart (emojiClick)="addEmoji($event)" [useButton]="true" (click)="stopEvent($event)"></emoji-mart>
      </mat-menu>
  
      <!-- Templates Button with Material Menu -->
      <ng-container *ngIf="isSendingMessage">
        <button type="button" mat-flat-button color="primary" class="template-btn" 
          [matMenuTriggerFor]="templateMenu" 
          #templateMenuTrigger="matMenuTrigger"
          (menuOpened)="onTemplateMenuOpened()">
          Templates
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #templateMenu="matMenu" class="template-menu-scrollable">
          <!-- Search input with create button -->
          <div class="template-search-container" (click)="$event.stopPropagation()">
            <mat-form-field appearance="outline" class="template-search-field" [subscriptSizing]="'dynamic'">
              <mat-icon matPrefix>search</mat-icon>
              <input matInput 
                #templateSearchInput
                [formControl]="templateSearchControl" 
                placeholder="Search templates..."
                (input)="onTemplateSearchChange($event)"
                autocomplete="off">
              <button mat-icon-button matSuffix *ngIf="templateSearchControl.value" 
                (click)="templateSearchControl.setValue(''); onTemplateSearchChange($event)">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <button mat-mini-fab color="primary" class="template-create-btn"
              (click)="onCreateTemplate($event)"
              matTooltip="Create new template">
              <mat-icon>add</mat-icon>
            </button>
          </div>

          <!-- Templates list with scroll -->
          <div class="template-menu-content" #templateMenuContent (scroll)="onTemplateMenuScroll($event)">
            <!-- Loading spinner for initial load -->
            <div *ngIf="isLoadingTemplates && templates.length === 0" class="template-loading">
              <mat-spinner diameter="30"></mat-spinner>
            </div>

            <!-- Template items with edit button -->
            <div class="template-menu-item" *ngFor="let template of templates">
              <button mat-menu-item class="template-select-btn" (click)="onTemplateSelect(template)">
                {{template.name}}
              </button>
              <button mat-icon-button class="template-edit-btn" 
                (click)="onEditTemplate($event, template)">
                <mat-icon>edit</mat-icon>
              </button>
            </div>

            <!-- No results message -->
            <div *ngIf="!isLoadingTemplates && templates.length === 0" class="no-templates">
              No templates found
            </div>

            <!-- Loading more spinner -->
            <div *ngIf="isLoadingMoreTemplates" class="template-loading-more">
              <mat-spinner diameter="20"></mat-spinner>
            </div>
          </div>
        </mat-menu>
      </ng-container>

      <!-- Translate Button -->
      <button type="button" mat-icon-button class="translate-btn" 
        [class.translated]="isTranslated"
        (click)="handleTranslate()"
        [matTooltip]="isTranslated ? 'Show original' : 'Translate message'"
        [disabled]="isTranslating || !formControl.value">
        <mat-icon>translate</mat-icon>
      </button>
    </div>
  
    <div class="toolbar-right">
      <!-- Other Fields Button with Material Menu -->
      <button type="button" mat-button [matMenuTriggerFor]="otherFieldsMenu" #otherFieldsMenuTrigger="matMenuTrigger"
        class="fields-btn">
        Other fields
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #otherFieldsMenu="matMenu" class="fields-menu">
        <ng-container *ngFor="let otherField of otherFields">
          <button (click)="onTagSelect(otherField)" mat-menu-item>
            <span>{{otherField.label}}</span>
            @if(!isSendingMessage){
            <mat-icon class="settings-button" (click)="onSettingsClick($event, otherField, otherFieldsMenuTrigger)"
              matTooltip="Settings">
              settings
            </mat-icon>
            }
          </button>
        </ng-container>
      </mat-menu>
  
      <!-- Leads Button with Material Menu -->
      <button type="button" mat-button [matMenuTriggerFor]="leadsMenu" #leadsMenuTrigger="matMenuTrigger"
        class="leads-btn">
        Leads
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #leadsMenu="matMenu" class="leads-menu">
        <ng-container *ngFor="let leads of leadTags">
          <button (click)="onTagSelect(leads)" mat-menu-item>
            <span>{{leads.label}}</span>
  
            @if(!isSendingMessage){
            <mat-icon class="settings-button" (click)="onSettingsClick($event, leads, leadsMenuTrigger)"
              matTooltip="Settings">
              settings
            </mat-icon>
            }
          </button>
        </ng-container>
      </mat-menu>
  
      <!-- Recent Button with Material Menu -->
      <button type="button" mat-button [matMenuTriggerFor]="recentMenu" #recentMenuTrigger="matMenuTrigger"
        class="recent-btn">
        Recent
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #recentMenu="matMenu" class="recent-menu">
        <ng-container *ngFor="let rec of recent">
          <button (click)="onTagSelect(rec)" mat-menu-item>
            <span>{{rec.label}}</span>
          </button>
        </ng-container>
      </mat-menu>
    </div>
  </div>

  <!-- Textarea container moved below the toolbar -->
  <div class="textarea-container">
    <textarea
      #textarea
      [formControl]="formControl"
      [placeholder]="placeholder"
      [style.height]="height"
      class="mat-elevation-z0"
      [readonly]="isTranslating"
      (input)="resetTranslationState()"
    ></textarea>
  </div>
</div>